import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day 10 - where the fuck did the week go?",
  "description": "",
  "published": "2009-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day-10-where-the-fuck-did-the-week-go/swizec/820"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It's been a while since I wrote anything for my Gonzo Steampunk Vampires, which is a shame since this story actually seems to be turning out a lot better than anything I've ever written (although it's still mostly crap) and as a reader of my brain I'm, surprisingly, starting to get a sense that there's something deeper behind the front tale. That there will be some meat on the bones of this story.`}</p>
    <p>{`All of this makes me yay!`}</p>
    <p>{`What does not make me yay is my complete and utter failure at writing. Despite having to write every day I haven't done anything in so long that today when I wanted to do some writing during a break between lectures I ... I ... I forgot where my story was. I completely and totally forgot what I was supposed to write!`}</p>
    <p>{`But in any regard, here are the 724 words I managed to muster today, hope you like 'em`}</p>
    <blockquote>
      <p parentName="blockquote">{`Moe rushed into class; wet under his nose, shoes pooling with water and the dumbest look on his face ever imaginable. A draft pulled the door from his hand and shut it closed. A deathly quiet filled the lecture hall.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      